<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
          <path d="M18 17V9"></path>
          <path d="M13 17V5"></path>
          <path d="M8 17v-3"></path>
        </svg>
        四维度分析
      </div>
    </div>
    <div class="p-6 pt-0">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div 
          v-for="(dimension, index) in dimensionResults"
          :key="dimension.id"
          class="space-y-4"
        >
          <div>
            <div class="flex justify-between items-center mb-2">
              <div class="flex items-center gap-2">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round" 
                  :class="`w-4 h-4 ${getDimensionColor(index)}`"
                  v-html="getDimensionIcon(index)"
                >
                </svg>
                <span class="font-medium">{{ getDimensionShortName(dimension.name) }}</span>
              </div>
              <span class="text-sm text-gray-600">{{ dimension.zScore.toFixed(2) }}</span>
            </div>
            <div class="relative w-full overflow-hidden rounded-full bg-gray-200 h-2">
              <div 
                class="h-full bg-psychology-primary transition-all duration-500"
                :style="{ width: getTScorePercentage(dimension.tScore) + '%' }"
              ></div>
            </div>
            <p class="text-xs text-gray-500 mt-1">{{ dimension.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DimensionAnalysis',
  props: {
    dimensionResults: {
      type: Array,
      required: true
    }
  },
  methods: {
    getDimensionColor(index) {
      const colors = [
        'text-psychology-primary',
        'text-psychology-secondary',
        'text-psychology-accent',
        'text-psychology-success'
      ]
      return colors[index % colors.length]
    },
    getDimensionIcon(index) {
      const icons = [
        // 控制欲望 - 眼睛图标
        '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
        // 嫉妒强度 - 心形图标
        '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
        // 情感依赖 - 链条图标
        '<path d="M8 2v3"></path><path d="M16 2v3"></path><rect width="16" height="11" x="4" y="7" rx="2"></rect><path d="M10 13v6"></path><path d="M14 13v6"></path>',
        // 关系不安 - 盾牌图标
        '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>'
      ]
      return icons[index % icons.length]
    },
    getDimensionShortName(name) {
      // 移除括号内容和"量表"字样
      return name.replace(/（.*?）/g, '').replace(/\(.*?\)/g, '').replace(/量表/g, '')
    },
    getTScorePercentage(tScore) {
      // 检查tScore是否存在且为数字
      if (typeof tScore !== 'number' || isNaN(tScore)) {
        return 0
      }
      
      // T分数范围映射到进度条百分比
      // 如果T分数在20-80范围内，使用标准映射
      if (tScore >= 20 && tScore <= 80) {
        return ((tScore - 20) / 60) * 100
      }
      // 如果T分数超出范围，进行线性映射
      else if (tScore < 20) {
        return (tScore / 20) * 25 // 0-20映射到0-25%
      } else if (tScore > 80) {
        return 75 + ((tScore - 80) / 20) * 25 // 80-100映射到75-100%
      }
      
      // 默认情况，直接使用T分数作为百分比
      return Math.max(0, Math.min(100, tScore))
    }
  }
}
</script>

